<template>
  <v-dialog
    v-model="dialog"
    width="500"
    >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="error"
        icon
        v-bind="attrs"
        v-on="on"
        >
        <v-icon>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        Eliminar complejo
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="dialog = false"
          >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        ¿Está seguro de que desea eliminar el complejo seleccionado? Esta acción <span class="error--text font-weight-medium">no se puede deshacer</span>.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          depressed
          color="error"
          @click="save"
          >
          Eliminar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DeleteBuilding } from '@/graphql/mutations/buildings'

export default {
  data: () => ({
    dialog: false
  }),

  props: {
    building: {
      required: true,
      type: Object,
    }
  },

  methods: {
    save () {
      this.$apollo.mutate({
        mutation: DeleteBuilding,
        variables: {
          input: {
            id: this.building.id
          }
        }
      }).then ( res => {
        this.$emit('reload')
        this.dialog = false
      })
    }
  }
}
</script>
